/* mm-komplett.js — „Alle vier Sorten" (Komplettset) auf Start- und Produktseite.
 *
 * 04.09.2026, Mert: „Mach eine Section. Wo Du alle Sorten, also das Komplettset,
 * auf der Seite und produkt seite gut bewirbst, marketingtechnisch.
 * design 21st.dev orientiert, und mit abo funktion, und auch bei upcart rein tun
 * als empfehlung, ohne irgendwas an der seite zu zerstören."
 *
 * BAUSTEIN: „Bento" von @kinfe123, aus Merts 21st-Sammlung „Bilder-Sections".
 * Ein Raster aus einer grossen und mehreren kleinen Flaechen - genau richtig
 * fuer EIN Angebot (das Set) mit VIER Bestandteilen (den Sorten). Ein Karussell
 * waere hier falsch: vier Dinge wischt niemand durch, die sollen alle zu sehen
 * sein.
 *
 * 1:1 UEBERNOMMEN: Rasteraufbau (grosse Flaeche + kleine daneben), Bild oben
 * und Textblock unten mit negativem Versatz und Milchglas darueber, feiner
 * heller Rahmen (1px rgba(255,255,255,.1)), der nach innen fallende Schein
 * (box-shadow inset von oben), Radius, Aufhellen beim Zeigen.
 *
 * UMGESTELLT: Farben auf die Marke (#151013 / #F3E9EC, Rot nur als Akzent, kein
 * pinker Text, keine rote Verlaufsflaeche), Theme-Schriften, aus React/
 * framer-motion/Tailwind wurde reines JS ohne Bibliothek. Der lila Schein des
 * Originals (#8686f01f) wird zu einem warmen roten Schein.
 *
 * DATEN KOMMEN LIVE AUS DEM SHOP: Titel, Preise, Vergleichspreis, Bilder und
 * Verfuegbarkeit werden ueber /products/<handle>.js geholt - nichts fest
 * eingetragen. Aendert Mert einen Preis in Shopify, stimmt die Sektion sofort.
 *
 * ABO: Der Umschalter „einmalig / im Abo" erscheint VON SELBST, sobald das
 * Komplettset einem Verkaufsplan zugeordnet ist. Am 04.09.2026 ist es das noch
 * nicht - die Zuordnung liegt bei Seal Subscriptions und laesst sich ueber die
 * API nicht setzen (fehlende Berechtigung write_purchase_options). Sobald Mert
 * das Produkt in Seal zur Gruppe „Monatsvorrat im Abo" hinzufuegt, ist der
 * Schalter da, ohne dass hier etwas geaendert werden muss.
 *
 * ZERSTOERT NICHTS: Die Sektion wird zusaetzlich eingehaengt, kein bestehender
 * Knoten wird angefasst, kein fremdes CSS ueberschrieben. Alle Namen beginnen
 * mit mmKo.
 */
(function () {
  'use strict';

  var ROT = '#E5142A';
  var K = 'cubic-bezier(.25,1,.5,1)';
  var SET = '4er-set-alle-sorten-das-komplettset';

  /* Die vier Sorten - Reihenfolge nach Umsatz, Standard zuerst. */
  var SORTEN = [
    { handle: 'magic-milk-for-x5',        name: 'Standard',    kurz: 'Neutral im Geschmack' },
    { handle: 'magic-milk-for-x5-erdbeer', name: 'Strawberry',  kurz: 'Die meistgekaufte' },
    { handle: 'zero-termo-milk-pro-milk',  name: 'Nuss & Creamy', kurz: 'Nussig und mild' },
    { handle: 'magic-fruit-strawberry',    name: 'Magic Fruit', kurz: 'Fruchtig, von Florea' }
  ];

  var css = [
    '#mmKo{background:#151013;color:#F3E9EC;padding:clamp(32px,5vw,58px) 0;',
      'position:relative;overflow:hidden}',
    '#mmKo *{box-sizing:border-box}',
    '#mmKo .mmKoInnen{max-width:1100px;margin:0 auto;padding:0 clamp(14px,3vw,22px)}',
    '#mmKo .mmKoKopf{margin:0 0 clamp(16px,3vw,26px);max-width:640px}',
    '#mmKo .mmKoAuge{display:inline-flex;align-items:center;gap:8px;margin:0 0 10px;',
      'font-size:.62rem;font-weight:800;letter-spacing:.14em;text-transform:uppercase;',
      'color:rgba(243,233,236,.62)}',
    '#mmKo .mmKoAuge:before{content:"";width:18px;height:2px;background:' + ROT + '}',
    '#mmKo h2{margin:0;font-size:clamp(1.7rem,4.6vw,2.5rem);line-height:1.04;',
      'letter-spacing:-.02em;font-weight:800;color:#F3E9EC}',
    '#mmKo .mmKoUnter{margin:9px 0 0;font-size:.88rem;line-height:1.6;',
      'color:rgba(243,233,236,.6)}',

    /* Das Raster - 1:1 der Baustein: eine grosse Flaeche, daneben die kleinen */
    '#mmKo .mmKoRaster{display:grid;grid-template-columns:1fr 1fr;gap:10px}',
    '@media(min-width:860px){#mmKo .mmKoRaster{grid-template-columns:repeat(6,1fr);gap:14px}}',
    '#mmKo .mmKoGross{grid-column:1/-1}',
    '@media(min-width:860px){#mmKo .mmKoGross{grid-column:span 4;grid-row:span 2}',
      '#mmKo .mmKoKlein{grid-column:span 2}}',

    '#mmKo .mmKoFeld{position:relative;display:flex;flex-direction:column;overflow:hidden;',
      'border-radius:16px;background:#1A1317;border:1px solid rgba(255,255,255,.10);',
      /* der nach innen fallende Schein des Bausteins - beim Original lila, hier warm */
      'box-shadow:0 -20px 80px -20px rgba(229,20,42,.16) inset,0 12px 34px rgba(0,0,0,.28);',
      'transition:border-color .35s ease,box-shadow .35s ease,transform .35s ' + K + '}',
    '@media(hover:hover){#mmKo .mmKoFeld:hover{border-color:rgba(255,255,255,.2);',
      'box-shadow:0 -20px 80px -20px rgba(229,20,42,.26) inset,0 16px 40px rgba(0,0,0,.34);',
      'transform:translateY(-2px)}}',

    '#mmKo .mmKoBild{position:relative;width:100%;overflow:hidden;background:#120D10}',
    /* 16:9 ist Absicht und keine Geschmacksfrage: das Studiobild liegt in
       900x506 vor, also exakt 16:9. Bei 16:10 schnitt `cover` links und
       rechts je rund 5 Prozent ab - gemessen 10 Prozent Verlust, und an
       den Raendern stehen die aeusseren Packungen mit ihrem Aufdruck.
       Merts feste Regel vom 21.08.2026: ein Bild mit eingebautem Text
       wird nie beschnitten. Gleiches Verhaeltnis heisst: nichts faellt weg. */
    '#mmKo .mmKoGross .mmKoBild{aspect-ratio:16/9}',
    '#mmKo .mmKoKlein .mmKoBild{aspect-ratio:1/1}',
    '#mmKo .mmKoBild img{width:100%;height:100%;object-fit:cover;display:block;',
      'transition:transform .8s ' + K + '}',
    '@media(hover:hover){#mmKo .mmKoFeld:hover .mmKoBild img{transform:scale(1.04)}}',

    /* Textblock schiebt sich unter das Bild - wie im Baustein, mit Milchglas */
    '#mmKo .mmKoText{position:relative;z-index:2;margin-top:-58px;padding:clamp(14px,2.4vw,22px);',
      '-webkit-backdrop-filter:blur(18px) saturate(150%);backdrop-filter:blur(18px) saturate(150%);',
      'background:linear-gradient(180deg,rgba(21,16,19,.42),rgba(21,16,19,.9) 62%)}',
    '#mmKo .mmKoKlein .mmKoText{margin-top:-44px;padding:12px 13px 14px}',
    '#mmKo .mmKoSchild{display:inline-block;margin:0 0 8px;font-size:.58rem;font-weight:800;',
      'letter-spacing:.12em;text-transform:uppercase;color:#fff;background:' + ROT + ';',
      'border-radius:999px;padding:4px 10px}',
    '#mmKo .mmKoTitel{margin:0;font-size:clamp(1.2rem,2.6vw,1.6rem);line-height:1.12;',
      'font-weight:800;letter-spacing:-.01em;color:#F3E9EC}',
    '#mmKo .mmKoKlein .mmKoTitel{font-size:.95rem}',
    '#mmKo .mmKoBesch{margin:8px 0 0;font-size:.85rem;line-height:1.6;',
      'color:rgba(243,233,236,.7);max-width:46ch}',
    '#mmKo .mmKoKlein .mmKoBesch{margin:3px 0 0;font-size:.7rem;color:rgba(243,233,236,.55)}',
    '#mmKo a.mmKoKlein{color:inherit;text-decoration:none;cursor:pointer}',
    '#mmKo a.mmKoKlein:focus-visible{outline:3px solid #F3E9EC;outline-offset:-4px}',

    /* Preiszeile */
    '#mmKo .mmKoPreis{display:flex;align-items:baseline;flex-wrap:wrap;gap:9px;margin:14px 0 0}',
    '#mmKo .mmKoJetzt{font-size:1.5rem;font-weight:850;color:#F3E9EC;letter-spacing:-.02em}',
    '#mmKo .mmKoVorher{font-size:.9rem;color:rgba(243,233,236,.45);text-decoration:line-through}',
    '#mmKo .mmKoSpar{font-size:.68rem;font-weight:800;letter-spacing:.06em;text-transform:uppercase;',
      'color:' + ROT + ';border:1px solid rgba(229,20,42,.45);border-radius:999px;padding:4px 10px}',
    '#mmKo .mmKoJeMonat{margin:5px 0 0;width:100%;font-size:.74rem;color:rgba(243,233,236,.5)}',
    '#mmKo .mmKoZahl{position:relative;display:inline-block;white-space:nowrap;',
      'font-variant-numeric:tabular-nums;line-height:1.1;vertical-align:baseline}',
    '#mmKo .mmKoZiffer{position:relative;display:inline-block;height:1.1em;',
      'line-height:1.1;overflow:hidden;vertical-align:bottom}',
    '#mmKo .mmKoBahn{position:absolute;left:0;top:0;width:100%;pointer-events:none}',
    '#mmKo .mmKoBahn span{display:block;height:1.1em;line-height:1.1}',
    '#mmKo .mmKoLesbar{position:absolute;width:1px;height:1px;padding:0;',
      'overflow:hidden;clip-path:inset(50%);white-space:nowrap}',
    '#mmKo .mmKoVorher .mmKoZahl:after{content:"";position:absolute;left:0;right:0;',
      'top:52%;border-top:1px solid currentColor;pointer-events:none}',

    /* Abo-Umschalter - erscheint nur, wenn es einen Verkaufsplan gibt */
    '#mmKo .mmKoAbo{display:none;margin:14px 0 0;gap:7px}',
    '#mmKo .mmKoAbo.mmKoDa{display:flex}',
    '#mmKo .mmKoAbo button{flex:1 1 0;cursor:pointer;font-family:inherit;font-size:.75rem;',
      'font-weight:700;padding:9px 10px;border-radius:11px;color:rgba(243,233,236,.72);',
      'background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.12);',
      'transition:background .25s ease,border-color .25s ease,color .25s ease}',
    '#mmKo .mmKoAbo button[aria-pressed="true"]{background:rgba(229,20,42,.14);',
      'border-color:rgba(229,20,42,.6);color:#F3E9EC}',
    '#mmKo .mmKoAbo button:focus-visible{outline:2px solid ' + ROT + ';outline-offset:2px}',

    '#mmKo .mmKoKnopf{display:block;width:100%;margin:14px 0 0;cursor:pointer;',
      'font-family:inherit;font-size:.95rem;font-weight:800;letter-spacing:.01em;',
      'padding:15px 18px;border-radius:14px;border:0;background:#F3E9EC;color:#151013;',
      'transition:transform .2s ' + K + ',box-shadow .25s ease}',
    '@media(hover:hover){#mmKo .mmKoKnopf:hover{transform:translateY(-1px);',
      'box-shadow:0 10px 26px rgba(0,0,0,.3)}}',
    '#mmKo .mmKoKnopf:disabled{opacity:.55;cursor:default;transform:none}',
    '#mmKo .mmKoKnopf:focus-visible{outline:2px solid ' + ROT + ';outline-offset:3px}',
    '#mmKo .mmKoFuss{margin:10px 0 0;font-size:.7rem;line-height:1.5;',
      'color:rgba(243,233,236,.42)}',

    '@media(prefers-reduced-motion:reduce){#mmKo *{transition:none!important}}'
  ].join('');

  function schuetzen(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function geld(cent) {
    return (cent / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* Gleiche 550 ms / Kurve wie mm-abo. Nur echte Preiswechsel rollen;
     beim ersten Sichtkontakt einmaliger Einstieg, kein Endlos-Zaehler. */
  function preisRollen(sek) {
    var zeile = sek.querySelector('.mmKoPreis');
    var media = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var elemente = [], sichtbar = false, gestartet = false, auge;

    function stoppen(el) {
      (el.mmKoLaeufe || []).forEach(function (a) { a.onfinish = null; a.cancel(); });
      el.mmKoLaeufe = [];
      [].forEach.call(el.querySelectorAll('.mmKoBahn'), function (b) { b.remove(); });
      [].forEach.call(el.querySelectorAll('.mmKoEnde'), function (b) { b.style.visibility = ''; });
    }
    function ruhe() { elemente.forEach(stoppen); }
    function malen(el, text, einstieg) {
      if (!el) return;
      if (elemente.indexOf(el) < 0) elemente.push(el);
      var alt = el.mmKoText || el.textContent;
      if (el.mmKoText === text && !einstieg) return;
      stoppen(el);
      el.mmKoText = text;
      var neu = /^(\d+[,.]\d{2}\s*\u20ac)(.*)$/.exec(text);
      var vorher = /^(\d+[,.]\d{2})/.exec(alt);
      if (!neu) { el.textContent = text; return; }
      var ziffern = neu[1].replace(/\D/g, '');
      var alte = einstieg ? '' : (vorher ? vorher[1].replace(/\D/g, '') : '');
      var richtung = Number(ziffern) >= Number(alte) ? 1 : -1;
      alte = ('000000000000' + alte).slice(-ziffern.length);
      var animieren = sichtbar && !document.hidden && !(media && media.matches);
      var i = 0, bahnen = [];
      var bild = neu[1].split('').map(function (c) {
        if (!/\d/.test(c)) return schuetzen(c);
        var von = Number(alte[i++]), zu = Number(c), folge = [von], n = von;
        while (n !== zu) { n = (n + richtung + 10) % 10; folge.push(n); }
        if (richtung < 0) folge.reverse();
        bahnen.push({ folge: folge, richtung: richtung });
        return '<span class="mmKoZiffer"><span class="mmKoEnde">' + c + '</span></span>';
      }).join('');
      /* Der echte Betrag ist fuer Screenreader sofort lesbar. Rollende
         Zwischenziffern sind rein visuell, Suffix bleibt uebersetzbarer Text. */
      el.innerHTML = '<span class="mmKoZahl"><span class="mmKoLesbar">' +
        schuetzen(neu[1]) + '</span><span aria-hidden="true" translate="no">' +
        bild + '</span></span>' + schuetzen(neu[2]);
      if (!animieren) return;
      [].forEach.call(el.querySelectorAll('.mmKoZiffer'), function (spalte, index) {
        var d = bahnen[index];
        if (d.folge.length < 2 || typeof spalte.animate !== 'function') return;
        var bahn = document.createElement('span');
        bahn.className = 'mmKoBahn';
        bahn.innerHTML = d.folge.map(function (z) { return '<span>' + z + '</span>'; }).join('');
        var ende = spalte.firstChild;
        ende.style.visibility = 'hidden';
        spalte.appendChild(bahn);
        var weg = 'translateY(-' + ((d.folge.length - 1) * 1.1) + 'em)';
        var a = bahn.animate([
          { transform: d.richtung > 0 ? 'translateY(0)' : weg },
          { transform: d.richtung > 0 ? weg : 'translateY(0)' }
        ], { duration: 550, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'forwards' });
        el.mmKoLaeufe.push(a);
        a.onfinish = function () {
          ende.style.visibility = ''; bahn.remove(); a.cancel();
          var at = el.mmKoLaeufe.indexOf(a);
          if (at > -1) el.mmKoLaeufe.splice(at, 1);
        };
      });
    }
    [].forEach.call(zeile.querySelectorAll('.mmKoJetzt,.mmKoVorher,.mmKoSpar,.mmKoJeMonat'), function (el) {
      malen(el, el.mmKoText || el.textContent, false);
    });
    function eintritt() {
      if (!sichtbar || document.hidden || gestartet) return;
      gestartet = true;
      elemente.forEach(function (el) { malen(el, el.mmKoText, true); });
    }
    function sichtwechsel() {
      if (document.hidden) ruhe(); else eintritt();
    }
    function abbauen() {
      ruhe(); if (auge) auge.disconnect();
      document.removeEventListener('visibilitychange', sichtwechsel);
      window.removeEventListener('pagehide', seitenwechsel);
      if (media && media.removeEventListener) media.removeEventListener('change', ruhe);
    }
    function seitenwechsel(e) { if (e.persisted) ruhe(); else abbauen(); }
    if (window.IntersectionObserver) {
      auge = new IntersectionObserver(function (eintraege) {
        if (!sek.isConnected) { abbauen(); return; }
        sichtbar = eintraege[0].isIntersecting && eintraege[0].intersectionRatio >= .3;
        if (sichtbar) eintritt(); else ruhe();
      }, { threshold: [0, .3] });
      auge.observe(zeile);
    }
    document.addEventListener('visibilitychange', sichtwechsel);
    window.addEventListener('pagehide', seitenwechsel);
    if (media && media.addEventListener) media.addEventListener('change', ruhe);
    return malen;
  }
  function produktUrl(handle) {
    var wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return wurzel.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle);
  }
  /* Upcart ersetzt window.fetch - deshalb XHR, das bleibt unangetastet. */
  function holen(pfad, dann) {
    var x = new XMLHttpRequest();
    x.open('GET', pfad, true);
    x.onload = function () {
      if (x.status < 200 || x.status >= 300) return dann(null);
      try { dann(JSON.parse(x.responseText)); } catch (e) { dann(null); }
    };
    x.onerror = function () { dann(null); };
    x.send();
  }

  function bauen(daten) {
    if (document.getElementById('mmKo')) return true;
    var set = daten.set;
    if (!set) return false;

    var st = document.createElement('style');
    st.id = 'mmKo-stil'; st.textContent = css;
    (document.head || document.documentElement).appendChild(st);

    var vorher = set.compare_at_price && set.compare_at_price > set.price
      ? set.compare_at_price : 0;
    var spart = vorher ? vorher - set.price : 0;

    var sek = document.createElement('section');
    sek.id = 'mmKo';
    sek.setAttribute('aria-label', 'Alle vier Sorten im Komplettset');
    sek.innerHTML =
      '<div class="mmKoInnen">' +
        '<div class="mmKoKopf">' +
          '<p class="mmKoAuge">Alle vier Sorten</p>' +
          '<h2>Einmal alles probieren — statt sich blind zu entscheiden</h2>' +
          '<p class="mmKoUnter">Vier Packungen, vier Geschmacksrichtungen, vier Monate ' +
            'Vorrat. Für alle, die noch nicht wissen, welche Sorte ihre ist.</p>' +
        '</div>' +
        '<div class="mmKoRaster">' +
          '<div class="mmKoFeld mmKoGross">' +
            '<div class="mmKoBild"><img src="' + schuetzen(bildVon(set, 900)) + '" ' +
              'alt="' + schuetzen(set.title) + '" loading="lazy" decoding="async"></div>' +
            '<div class="mmKoText">' +
              (spart ? '<span class="mmKoSchild">' + geld(spart) + ' günstiger</span>' : '') +
              '<h3 class="mmKoTitel">Das Komplettset</h3>' +
              '<p class="mmKoBesch">Jede Sorte einmal — Standard, Strawberry, ' +
                'Nuss &amp; Creamy und Magic Fruit. Jede Packung 30 Sticks, einer am Tag.</p>' +
              '<div class="mmKoPreis">' +
                '<span class="mmKoJetzt">' + geld(set.price) + '</span>' +
                (vorher ? '<span class="mmKoVorher">' + geld(vorher) + '</span>' : '') +
                (spart ? '<span class="mmKoSpar">' + geld(spart) + ' gespart</span>' : '') +
                '<span class="mmKoJeMonat">' + geld(Math.round(set.price / 4)) +
                  ' je Packung · 120 Sticks · vier Monate</span>' +
              '</div>' +
              '<div class="mmKoAbo" role="group" aria-label="Kaufart">' +
                '<button type="button" class="mmKoEinmal" aria-pressed="true">Einmalig</button>' +
                '<button type="button" class="mmKoImAbo" aria-pressed="false">Im Abo sparen</button>' +
              '</div>' +
              '<button type="button" class="mmKoKnopf">In den Warenkorb</button>' +
              '<p class="mmKoFuss">Preise und Verfügbarkeit direkt aus dem Shop. ' +
                'Versand aus Deutschland.</p>' +
            '</div>' +
          '</div>' +
          daten.sorten.map(function (s) {
            return '<a class="mmKoFeld mmKoKlein" href="' + schuetzen(produktUrl(s.handle)) + '">' +
              '<div class="mmKoBild"><img src="' + schuetzen(s.bild) + '" alt="' +
                schuetzen(s.name) + '" loading="lazy" decoding="async"></div>' +
              '<div class="mmKoText">' +
                '<h3 class="mmKoTitel">' + schuetzen(s.name) + '</h3>' +
                '<p class="mmKoBesch">' + schuetzen(s.kurz) + '</p>' +
              '</div>' +
            '</a>';
          }).join('') +
        '</div>' +
      '</div>';

    var anker = zielAnker();
    if (!anker || !anker.parentNode) return false;
    anker.parentNode.insertBefore(sek, anker.nextSibling);

    /* --- Abo, wenn es einen Verkaufsplan gibt ------------------------------- */
    var plaene = (set.selling_plan_groups || []).reduce(function (alle, g) {
      return alle.concat(g.selling_plans || []);
    }, []);

    /* WELCHER Plan, wenn es mehrere gibt: der mit dem groessten Vorteil.
       Frueher stand hier `plaene[plaene.length - 1]` mit dem Kommentar
       „laengster Plan" - das war falsch. Die Reihenfolge im JSON sagt gar
       nichts ueber die Laufzeit, und am 04.09.2026 waere daraus beim
       Komplettset der Jahresplan geworden. Das Storefront-JSON liefert das
       Lieferintervall nicht mit (`delivery_policy` kommt leer), deshalb ist
       der Rabatt das einzige belastbare Merkmal - und zugleich das, was fuer
       den Kunden zaehlt. */
    function ersparnisVon(plan) {
      var a = (plan.price_adjustments || [])[0];
      if (!a) return 0;
      if (a.value_type === 'percentage') return set.price * a.value / 100;
      if (a.value_type === 'fixed_amount') return a.value;
      if (a.value_type === 'price') return Math.max(0, set.price - a.value);
      return 0;
    }
    var plan = null;
    for (var pi = 0; pi < plaene.length; pi++) {
      if (!plan || ersparnisVon(plaene[pi]) > ersparnisVon(plan)) plan = plaene[pi];
    }
    var planId = plan ? plan.id : null;
    var imAbo = false;
    /* Originaltexte vor dem Aufteilen der Ziffern erfassen. */
    var preisSetzen;

    if (planId) {
      sek.querySelector('.mmKoAbo').classList.add('mmKoDa');
      var kEinmal = sek.querySelector('.mmKoEinmal');
      var kAbo = sek.querySelector('.mmKoImAbo');

      /* Der Preis muss mitgehen. Ohne das klickt der Kunde „Im Abo sparen"
         und sieht dieselbe Zahl wie vorher - dann ist der Vorteil unsichtbar
         und der Schalter wirkt kaputt. */
      var eJetzt   = sek.querySelector('.mmKoJetzt');
      var eVorher  = sek.querySelector('.mmKoVorher');
      var eSpar    = sek.querySelector('.mmKoSpar');
      var eJeMonat = sek.querySelector('.mmKoJeMonat');
      var urJetzt   = eJetzt   ? eJetzt.textContent   : '';
      var urVorher  = eVorher  ? eVorher.textContent  : '';
      var urSpar    = eSpar    ? eSpar.textContent    : '';
      var urJeMonat = eJeMonat ? eJeMonat.textContent : '';
      var aboPreis  = Math.round(set.price - ersparnisVon(plan));

      function anzeigen(ab) {
        if (ab) {
          preisSetzen(eJetzt, geld(aboPreis));
          preisSetzen(eVorher, geld(set.price));
          preisSetzen(eSpar, geld(set.price - aboPreis) + ' gespart');
          preisSetzen(eJeMonat, geld(Math.round(aboPreis / 4)) +
            ' je Packung \u00b7 alle vier Monate neu \u00b7 jederzeit k\u00fcndbar');
        } else {
          preisSetzen(eJetzt, urJetzt);
          preisSetzen(eVorher, urVorher);
          preisSetzen(eSpar, urSpar);
          preisSetzen(eJeMonat, urJeMonat);
        }
      }

      kEinmal.addEventListener('click', function () {
        imAbo = false; kEinmal.setAttribute('aria-pressed', 'true');
        kAbo.setAttribute('aria-pressed', 'false');
        anzeigen(false);
      });
      kAbo.addEventListener('click', function () {
        imAbo = true; kAbo.setAttribute('aria-pressed', 'true');
        kEinmal.setAttribute('aria-pressed', 'false');
        anzeigen(true);
      });
    }

    preisSetzen = preisRollen(sek);

    /* --- Kaufen ------------------------------------------------------------- */
    var knopf = sek.querySelector('.mmKoKnopf');
    var variante = set.variants && set.variants[0];
    if (!variante || variante.available === false) {
      knopf.disabled = true;
      knopf.textContent = 'Zurzeit nicht verfügbar';
    }
    knopf.addEventListener('click', function () {
      if (knopf.disabled) return;
      var alt = knopf.textContent;
      knopf.disabled = true; knopf.textContent = 'Wird hinzugefügt …';
      var koerper = { id: variante.id, quantity: 1 };
      if (imAbo && planId) koerper.selling_plan = planId;
      var x = new XMLHttpRequest();
      x.open('POST', '/cart/add.js', true);
      x.setRequestHeader('Content-Type', 'application/json');
      x.onload = function () {
        knopf.disabled = false;
        if (x.status >= 200 && x.status < 300) {
          knopf.textContent = 'Im Warenkorb ✓';
          /* Upcart und das Theme ueber den neuen Stand unterrichten. */
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          if (window.UpCart && typeof window.UpCart.openCart === 'function') {
            window.setTimeout(function () { window.UpCart.openCart(); }, 250);
          }
          window.setTimeout(function () { knopf.textContent = alt; }, 2600);
        } else {
          knopf.textContent = 'Bitte noch einmal';
          window.setTimeout(function () { knopf.textContent = alt; }, 2600);
        }
      };
      x.onerror = function () {
        knopf.disabled = false; knopf.textContent = alt;
      };
      x.send(JSON.stringify(koerper));
    });

    return true;
  }

  function bildVon(p, breite) {
    var u = p.featured_image || (p.images && p.images[0]) || '';
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u.indexOf('?') > -1 ? u + '&width=' + breite : u + '?width=' + breite;
  }

  /* Wo die Sektion hin soll:
     - Produktseite: unter „Kennst du das?" (#mmPu), sonst unter „Mehr zum Produkt"
     - Startseite:   unter die Bestseller-Reihe, sonst vor den Fussbereich */
  function zielAnker() {
    var p = document.getElementById('mmPu') || document.getElementById('mmWi');
    if (p) return p;
    var b = document.getElementById('mmAk') || document.querySelector('[id*="ss_slider"]');
    if (b) return b;
    var abschnitte = document.querySelectorAll('.shopify-section');
    return abschnitte.length ? abschnitte[abschnitte.length - 2] : null;
  }

  function laden() {
    holen('/products/' + SET + '.js', function (set) {
      if (!set) return;
      var sorten = [], offen = SORTEN.length;
      SORTEN.forEach(function (s, i) {
        holen('/products/' + s.handle + '.js', function (p) {
          sorten[i] = { handle: s.handle, name: s.name, kurz: s.kurz, bild: p ? bildVon(p, 500) : '' };
          if (--offen === 0) {
            starten({ set: set, sorten: sorten.filter(function (x) { return x && x.bild; }) });
          }
        });
      });
    });
  }

  var gebaut = false;
  function starten(daten) {
    if (gebaut) return;
    if (bauen(daten)) { gebaut = true; return; }
    var n = 0;
    var t = window.setInterval(function () {
      n++;
      if (bauen(daten)) { gebaut = true; window.clearInterval(t); return; }
      if (n > 40) window.clearInterval(t);
    }, 700);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', laden);
  } else { laden(); }
})();
